import React from "react";
const MathSection = () => {
    return (
        <div id={"math"}>
            <h3>Math</h3>
            <p>
                Use Math blocks to compute values and work with numbers. The Math toolbox category
                includes blocks to perform math operations (addition, subtraction, multiplication,
                division, square root, etc...), generate random numbers, and provide mathematical
                constants such as pi.

                <div className={'imageContainer'}>
                    <img src="images/math.png" alt="Math Widgets" />
                </div>
            </p>
        </div>

    );

}

export default MathSection;
